import {
  SubscribedRFThermostat,
  SubscribedThermostat,
  SubscribedThermostats,
} from '@energybox/react-ui-library/dist/types/SubscribedThermostat';
import {
  isDefined,
  normalizeSubscribedThermostat,
} from '@energybox/react-ui-library/dist/utils';
import assocPath from 'ramda/src/assocPath';
import pipe from 'ramda/src/pipe';
import mergeDeepLeft from 'ramda/src/mergeDeepLeft';
import { Actions as StreamActions } from '../actions/streamApi';
import { normalizeSubscribedRFThermostatStatus } from '@energybox/react-ui-library/dist/utils/thermostat';

const initialState = {
  byId: {},
  byRFId: {},
};

const subscribedThermostats = (
  state: SubscribedThermostats = initialState,
  action: any
) => {
  switch (action.type) {
    case StreamActions.RECEIVED_DEVICE_READING: {
      //only process venstar thermostats and energybox thermostats
      if (
        action.data.vendor !== 'venstar' &&
        action.data.vendor !== 'energybox'
      ) {
        return state;
      }
      //RFThermostatStatus is an energybox thermostat with no CAM attached
      if (action.data.messageType === 'RFThermostatStatus') {
        let normalizedData: SubscribedRFThermostat;
        normalizedData = normalizeSubscribedRFThermostatStatus(action.data);
        return pipe(
          assocPath(
            ['byRFId', action.data.id],
            mergeDeepLeft(normalizedData, state.byRFId?.[action.data.id] || {})
          )
        )(state);
      } else {
        //RFThermostatCamStatus is an energybox thermostat with CAM attached
        let normalizedData: SubscribedThermostat;
        normalizedData = normalizeSubscribedThermostat(action.data);
        const readingType = normalizedData?.readingType;
        //reading type is available for venstar thermostat
        if (!isDefined(readingType)) {
          return state;
        } else {
          return pipe(
            assocPath(
              ['byId', action.data.id],
              mergeDeepLeft(normalizedData, state.byId?.[action.data.id] || {})
            )
          )(state);
        }
      }
    }

    default:
      return state;
  }
};

export default subscribedThermostats;
